import { EventActivityFeed } from '@/components/activity/EventActivityFeed';

import { useTeamDetailContext } from './teamDetailContext';

/**
 * Full team activity — same shared feed used on the event Activity
 * tab, scoped to this team.
 */
export function EventTeamActivityTab() {
  const { eventId, teamId } = useTeamDetailContext();
  return <EventActivityFeed eventId={eventId} teamId={teamId} limit={200} title="Team Activity" />;
}
